<template>
  <v-container fluid background>
    <!-- Form -->
    <v-layout row wrap v-show="!showLoading">
      <!-- <v-flex xs12>
        <v-layout row wrap>
          <v-flex md6 sm6 xs12 pa-1>
            <v-text-field
              label="เวลาสแกนซ้ำ(นาที)"
              v-model="general_setting.finger_scan"
              type="number"
              hide-details
            />
          </v-flex>
          <v-flex md6 sm6 xs12 pa-1>
            <v-text-field
              label="เวลาเริ่มคำนวนสาย(นาที)"
              v-model="general_setting.start_cal_late"
              type="number"
              hide-details
            />
          </v-flex>
          <v-flex md6 sm6 xs12 pa-1>
            <v-text-field
              label="จำนวนวันทำงานที่ใช้คำนวณ(วัน)"
              v-model="general_setting.cal_work_day"
              type="number"
              hide-details
            />
          </v-flex>
          <v-flex md6 sm6 xs12 pa-1>
            <v-text-field
              label="ทศนิยม คำนวณเงิน(นาที)"
              v-model="general_setting.cal_decimal"
              type="number"
              hide-details
            />
          </v-flex>
          <v-flex md6 sm6 xs12 style="padding-top: 12px;">
            <h3>รูปแบบการแสดงปี</h3>
            <v-layout row wrap>
              <v-flex xs12 px-2>
                <v-radio-group v-model="general_setting.format_date" :column="false" hide-details>
                  <template>
                    <v-radio label="พ.ศ." value="0" />
                    <v-radio label="ค.ศ." value="1" />
                  </template>
                </v-radio-group>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex md6 sm6 xs12 style="padding-top: 12px;">
            <h3>รูปแบบการแสดงสัญลักษณ์เงินตรา</h3>
            <v-layout row wrap>
              <v-flex xs12 px-2>
                <v-radio-group v-model="general_setting.symbols_style" :column="false" hide-details>
                  <template>
                    <v-radio label="ก่อน" value="0" />
                    <v-radio label="หลัง" value="1" />
                  </template>
                </v-radio-group>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex md6 sm6 xs12 pt-2 px-1>
            <v-text-field
              label="สัญลักษณ์เงินตรา"
              v-model="general_setting.currency_symbols"
              hide-details
              placeholder="ตย. บาท"
            />
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex md12 sm12 xs12 pt-3>
            <h3>อัตราเงินประกันสังคม</h3>
          </v-flex>

          <v-flex md2 sm4 xs6 pa-1>
            <v-text-field
              label="อัตรา(%)"
              v-model="general_setting.ss_rate"
              type="number"
              hide-details
            />
          </v-flex>
          <v-flex md2 sm4 xs6 pa-1>
            <v-text-field label="ฐาน" v-model="general_setting.ss_base" type="number" hide-details />
          </v-flex>
        </v-layout>
      </v-flex>-->

      <v-flex xs12 text-xs-right pa-3>
        <v-expansion-panel v-model="panel" expand>
          <!-- เวลา -->
          <!-- <v-expansion-panel-content
            style="background-color:#2196F3;border-radius:5px;color:#fff;"
            :key="0"
          >
            <div slot="header">
              <h3>{{$t('timesetting')}}</h3>
            </div>
            <v-card>
              <v-card-text>
                <v-layout row wrap pa-4>
                  <v-flex md12 sm12 xs12>
                    <v-layout row wrap>
                      <v-flex md6 sm6 xs12 pa-1>
                        <v-text-field
                          :label="$t('RepeatScanTime')"
                          v-model="general_setting.finger_scan"
                          type="number"
                          hide-details
                        />
                      </v-flex>
                      <v-flex md6 sm6 xs12 pa-1>
                        <v-text-field
                          :label="$t('StartCalculatingLateTime')"
                          v-model="general_setting.start_cal_late"
                          type="number"
                          hide-details
                        />
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-card>
          </v-expansion-panel-content> -->
          <!-- รูปแบบการแสดงผล -->
          <v-expansion-panel-content
            style="background-color:#2196F3;border-radius:5px;color:#fff;"
            :key="0"
          >
            <div slot="header">
              <h3>{{$t('displayformat')}}</h3>
            </div>
            <v-card>
              <v-card-text>
                <v-layout row wrap pa-4>
                  <v-flex md12 sm12 xs12>
                    <v-layout row wrap>
                      <!-- <v-flex md6 sm6 xs12 style="padding-top: 12px;">
                        <h3>รูปแบบการแสดงปี</h3>
                        <v-layout row wrap>
                          <v-flex xs12 px-2>
                            <v-radio-group
                              v-model="general_setting.format_date"
                              :column="false"
                              hide-details
                            >
                              <template>
                                <v-radio label="พ.ศ." value="0" />
                                <v-radio label="ค.ศ." value="1" />
                              </template>
                            </v-radio-group>
                          </v-flex>
                        </v-layout>
                      </v-flex>-->
                      <v-flex md6 sm6 xs12 style="padding-top: 12px;">
                        <h3>{{$t('Currencysymbolformat')}}</h3>
                        <v-layout row wrap>
                          <v-flex xs12 px-2>
                            <v-radio-group
                              v-model="general_setting.symbols_style"
                              :column="false"
                              hide-details
                            >
                              <template>
                                <v-radio :label="$t('Before')" value="0" />
                                <v-radio :label="$t('After')" value="1" />
                              </template>
                            </v-radio-group>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                      <v-flex md6 sm6 xs12 pt-2 px-1>
                        <v-text-field
                          :label="$t('Currencysymbol')"
                          v-model="general_setting.currency_symbols"
                          hide-details
                          placeholder="ตย. บาท"
                        />
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-card>
          </v-expansion-panel-content>
          <!-- การคำนวณ -->
          <v-expansion-panel-content
            style="background-color:#2196F3;border-radius:5px;color:#fff;"
            :key="1"
          >
            <div slot="header">
              <h3>{{$t('calculationmethod')}}</h3>
            </div>
            <v-card>
              <v-card-text>
                <v-layout row wrap pa-4>
                  <v-flex md12 sm12 xs12>
                    <v-layout row wrap>
                      <v-flex md6 sm6 xs12 pa-1>
                        <v-text-field
                          :label="$t('Workdaycal')"
                          v-model="general_setting.cal_work_day"
                          type="number"
                          hide-details
                        />
                      </v-flex>
                      <!-- <v-flex md6 sm6 xs12 pa-1> -->
                      <!-- <v-text-field
              label="ทศนิยม คำนวณเงิน(นาที)"
              v-model="general_setting.cal_decimal"
              type="number"
              hide-details
                      />-->
                      <!-- <v-layout row wrap>
                          <v-flex md12 sm12 xs12 pa-1>
                            <h3>{{$t('listDeductions')}}</h3>
                            <v-layout row wrap>
                              <v-flex lg6 md6 sm6 xs12 pa-1>
                                <v-checkbox
                                  v-model="is_use_cal_ss"
                                  class="mx-2"
                                  @change="changeTaxVal1()"
                                  :label="$t('Usesocialsecuritypaymentsystem')"
                                ></v-checkbox>
                              </v-flex>
                              <v-flex md6 sm6 xs12 pa-1>
                                <v-checkbox
                                  v-model="is_use_cal_tax"
                                  class="mx-2"
                                  @change="changeTaxVal()"
                                  :label="$t('Usetaxcalculationsystem')"
                                ></v-checkbox>
                              </v-flex>
                            </v-layout>
                          </v-flex>
                        </v-layout>
                      </v-flex>-->
                    </v-layout>
                    <v-layout row wrap>
                      <v-flex md12 sm12 xs12 pa-1 style="margin-top:15px;">
                        <h3>{{$t('listDeductions')}}</h3>
                        <v-layout row wrap>
                          <v-flex lg6 md6 sm12 xs12 pa-1> 
                            <h4>{{$t('SocialSecurity')}}</h4>
                            <v-checkbox
                              v-model="is_use_cal_ss"
                              class="mx-2"
                              @change="changeTaxVal1()"
                              :label="$t('Usesocialsecuritypaymentsystem')"
                            ></v-checkbox>
                        
                            <v-layout row wrap>

                              <v-flex md6 sm6 xs6 pa-1>
                                <v-text-field
                                  :label="$t('SocialSecurityrate')+' ( % )'"
                                  v-model="general_setting.ss_rate"
                                  type="number"
                                  hide-details
                                />
                              </v-flex>
                              <v-flex md6 sm6 xs6 pa-1>
                                <v-text-field
                                  :label="$t('base')"
                                  v-model="general_setting.ss_base"
                                  type="number"
                                  hide-details
                                />
                              </v-flex>
                            </v-layout>
                          </v-flex>
                          <v-flex lg6 md6 sm12 xs12 pa-1>
                            <h4>{{$t('Tax')}}</h4>
                             <v-flex lg12 md6 sm6 xs6 pa-1>
                                  <v-radio-group v-model="checkuse_cal_tax" row>
                                    <v-radio :label="$t('Notusetaxcalculationsystem')" v-bind:value="0"></v-radio>
                                    <v-radio :label="$t('Usetaxcalculationsystem')" v-bind:value="1"></v-radio>
                                  </v-radio-group>
                              </v-flex>
                            <v-layout row wrap v-if="this.checkuse_cal_tax == 1">
                              <v-flex md6 sm6 xs6 pa-1>
                                  <v-radio-group v-model="general_setting.tax_type" row>
                                    <v-radio :label="$t('DeductTaxOnIncomeBasis')" v-bind:value="0"></v-radio>
                                    <v-radio :label="$t('LessDeferredIncomeTax')" v-bind:value="1"></v-radio>
                                  </v-radio-group>
                              </v-flex>

                               <v-flex md6 sm6 xs6 pa-1 v-if="this.general_setting.tax_type == 1">
                                <v-text-field
                                  v-model="general_setting.tax_number_percent"
                                  :label="$t('LessDeferredIncomeTax')"
                                  type="number"
                                  hide-details
                                />
                              </v-flex>
                              <!-- <v-flex md6 sm6 xs6 pa-1>
                                <v-text-field
                                  :label="$t('DeductTaxOnIncomeBasis')"
                                  type="number"
                                  hide-details
                                />
                              </v-flex> -->
                            </v-layout>
                          </v-flex>
                        </v-layout>
                        
                      </v-flex>
                    </v-layout>
                    <!-- <v-layout row wrap>
                      <v-flex md12 sm12 xs12 pt-3>
                        <h3>{{$t('SocialSecurityrate')}}</h3>
                      </v-flex>
                      <v-flex md6 sm6 xs6 pa-1>
                        <v-text-field
                          :label="$t('Rate')"
                          v-model="general_setting.ss_rate"
                          type="number"
                          hide-details
                        />
                      </v-flex>
                      <v-flex md6 sm6 xs6 pa-1>
                        <v-text-field
                          :label="$t('base')"
                          v-model="general_setting.ss_base"
                          type="number"
                          hide-details
                        />
                      </v-flex>
                    </v-layout> -->
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-card>
          </v-expansion-panel-content>
          <!-- ปรับค่าการจ่ายเงิน -->
          <v-expansion-panel-content
            style="background-color:#2196F3;border-radius:5px;color:#fff;"
            :key="2"
          >
            <div slot="header">
              <h3>{{$t('menu.DecimalSetting')}}</h3>
            </div>
            <v-card>
              <v-card-text>
                <v-layout row wrap pa-4 v-for="(item, index) in data_decimal" :key="index">
                  <v-flex md2 sm2 xs5 pa-1>
                    <v-text-field
                      :label="$t('Fromtheamount')"
                      v-model="item.from_value"
                      hide-details
                    />
                  </v-flex>
                  <v-flex md1 sm1 xs1 pa-1>
                    <h1 class="text-xs-center" style="padding-top: 0.5rem;">-</h1>
                  </v-flex>
                  <v-flex md2 sm2 xs5 pa-1>
                    <v-text-field :label="$t('Toamount')" v-model="item.to_value" hide-details />
                  </v-flex>
                  <v-flex md1 sm1 xs1 pa-1>
                    <h1 class="text-xs-center" style="padding-top: 0.5rem;">=</h1>
                  </v-flex>
                  <v-flex md2 sm2 xs4 pa-1>
                    <v-text-field :label="$t('As')" v-model="item.total_value" hide-details />
                  </v-flex>
                </v-layout>
                <v-layout row wrap py-2>
                  <v-flex xs12>
                    <v-btn color="success" @click="plusBox()">
                      <v-icon :size="16">fa-plus</v-icon>
                      <span class="ml-2">{{$t('Add_step')}}</span>
                    </v-btn>
                    <v-btn color="warning" @click="delBox()">
                      <v-icon :size="16">fa-minus</v-icon>
                      <span class="ml-2">{{$t('Step_down')}}</span>
                    </v-btn>
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-card>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-flex>
      <v-flex xs12 text-xs-right pa-3 v-if="permission_edit == true || admin == 'true'">
        <v-btn color="success" @click="general_setting.length == 0 ? onSave() : onUpdate()">
          <v-icon>save</v-icon>
          <span class="px-2">{{ general_setting.length == 0 ? $t('create') : $t('save') }}</span>
        </v-btn>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
/* eslint-disable */
import { mapState, mapActions, mapMutations } from "vuex";
import SettingService from "@/services/SettingService";
import UserService from "@/services/UserService";
export default {
  data: () => ({
    panel: [true, false, false],
    disabled: false,
    readonly: false,
    is_use_cal_tax: "0",
    is_use_cal_ss: true,
    general_setting: {
      roworder: 0,
      finger_scan: 0,
      start_cal_late: 0,
      cal_work_day: 30,
      cal_decimal: 0,
      editor_code: "",
      code: "000-1",
      format_date: 0,
      symbols_style: 0,
      currency_symbols: "",
      ss_base: 0,
      ss_rate: 0,
      use_cal_tax: "",
      use_cal_ss: "",
      tax_type:0,
      tax_number_percent:0,
      company_id: localStorage._company_guid,
    },
    data_decimal: [{ line: 1, from_value: 0, to_value: 0, total_value: 0 ,company_id: localStorage._company_guid}],
    checkbox: true,
    checkuse_cal_tax: "",
    checkuse_cal_ss: "",
    permission_edit: false,
    permission_view: false,
    admin: false,
    empCode: localStorage._empcode,
    permission: [],
  }),
  created: async function () {
    this.admin = localStorage._is_admin;
    await UserService.getpermissionByusercode(this.empCode)
      .then((res) => {
        this.permission = res.data.permission;
        console.log(res);
      })
      .catch((err) => {});
    await this.checkpermission("GeneralSetting");
    console.log(this.check_permission);
    this.commitSetToolbar({
      patternTool: "2",
    });
    this.getGeneralSetting();
    this.getDecimalSetting();
    //this.changeTaxVal();
    this.changeTaxVal1();
  },
  destroyed: function () {
    this.commitToggleAlertDialog({
      status: false,
      message: Object,
    });
  },
  computed: {
    ...mapState("app", ["showLoading"]),
    //...mapState("permissionmenu", ["permission_List"]),
  },
  methods: {
    ...mapActions("app", [
      "commitSetToolbar",
      "commitSetShowLoading",
      "commitGeneralSetting",
    ]),
    ...mapActions("alert", ["commitToggleAlertDialog"]),
    getGeneralSetting() {
      this.commitSetShowLoading(true);
      SettingService.getGeneralSetting()
        .then((res) => {
           
          console.log("getGeneralSetting", res);
          if (res.data.content.length > 0) {
            this.general_setting = res.data.content[0];
            let format_date =
              res.data.content[0].format_date != null
                ? res.data.content[0].format_date.toString()
                : "1";
            let symbol_styles =
              res.data.content[0].currency_symbols != null
                ? res.data.content[0].currency_symbols.toString()
                : "บาท";
            let currency_symbols =
              res.data.content[0].symbols_style != null
                ? res.data.content[0].symbols_style.toString()
                : "1";
          //  if(this.general_setting.tax_type == undefined){
          //       this.general_setting.tax_type = 0;
          //  }
          // if(this.general_setting.tax_number_percent == undefined){
          //      this.general_setting.tax_number_percent = 0;
          //   }
            this.general_setting.format_date = format_date;
            this.general_setting.currency_symbols = symbol_styles;
            this.general_setting.symbols_style = currency_symbols;
            this.checkuse_cal_tax = this.general_setting.use_cal_tax;
            this.checkuse_cal_ss = this.general_setting.use_cal_ss;
            console.log("getGeneralSetting if", this.general_setting);
            console.log("checkuse_cal_tax if", this.checkuse_cal_tax);
            console.log("checkuse_cal_ss if", this.checkuse_cal_ss);

            this.commitGeneralSetting({
              format_date: format_date,
              symbol_styles: symbol_styles,
              currency_symbols: currency_symbols,
            });
          }
        })
        .catch((err) => {
          this.commitToggleAlertDialog({
            status: true,
            message: err.response.data,
          });
        })
        .then(() => {
          this.commitSetShowLoading(false);
        });
    },
    checkpermission(page) {
      let checkEdit = false;
      let checkView = false;
      if (this.permission.length != 0) {
        this.permission.forEach((element) => {
          if (page == element.module_name) {
            checkEdit = element.edit;
            checkView = element.reads;
          }
        });
      } else {
        checkEdit = false;
        checkView = false;
      }
      this.permission_edit = checkEdit;
      this.permission_view = checkView;
    },
    onSave() {
      this.commitSetShowLoading(true);
      this.general_setting.editor_code;
      this.general_setting.company_id = localStorage._company_guid;
      SettingService.saveGeneralSetting(this.general_setting)
        .then((res) => {
          this.getGeneralSetting();
        })
        .catch((err) => {
          this.commitToggleAlertDialog({
            status: true,
            message: err.response.data,
          });
        })
        .then(() => {
          this.commitSetShowLoading(false);
        });
      this.onSaveDecimal();
    },
    onUpdate() {
      this.commitSetShowLoading(true);
      this.general_setting.editor_code;
      this.general_setting.company_id = localStorage._company_guid;
      SettingService.updateGeneralSetting(this.general_setting)
        .then((res) => {
          this.getGeneralSetting();
        })
        .catch((err) => {
          this.commitToggleAlertDialog({
            status: true,
            message: err.response.data,
          });
        })
        .then(() => {
          this.commitSetShowLoading(false);
        });
      this.onSaveDecimal();
    },

    //ปรับค่าการจ่ายเงิน
    getDecimalSetting() {
      this.commitSetShowLoading(true);
      SettingService.getDecimalSetting()
        .then((res) => {
          console.log("getDecimalSetting", res);
          if (res.data.content.length > 0) {
            this.data_decimal = res.data.content;
          }
        })
        .catch((err) => {
          this.commitToggleAlertDialog({
            status: true,
            message: err.response.data,
          });
        })
        .then(() => {
          this.commitSetShowLoading(false);
        });
    },
    onSaveDecimal() {
      SettingService.saveDecimal(this.data_decimal)
        .then((res) => {
          this.getDecimalSetting();
          //this.showLoading = false;
        })
        .catch((err) => {
          this.commitToggleAlertDialog({
            status: true,
            message: err.response.data,
          });
        })
        .then(() => {
          this.commitSetShowLoading(false);
        });
    },
    plusBox() {
      var line = this.data_decimal.length + 1;
      this.data_decimal.push({
        line: line,
        from_value: 0,
        to_value: 0,
        total_value: 0,
        company_id: localStorage._company_guid
      });
    },
    delBox() {
      this.data_decimal.splice(-1, 1);
    },
    // changeTaxVal() {
    //   console.log("this.checkuse_cal_tax changeTaxVal", this.is_use_cal_tax);
    //   // if (this.checkuse_cal_tax == "0") {
    //   //   this.is_use_cal_tax = false;
    //   //   console.log("if ", this.general_setting.use_cal_tax);
    //   //   console.log("if tax", this.is_use_cal_tax);
    //   // } else if(this.checkuse_cal_tax == "1") {
    //   //    this.is_use_cal_tax = true;
    //   //   console.log("else ", this.general_setting.use_cal_tax);
    //   // }
    //   // console.log("da", this.general_setting.use_cal_tax);
    //   if (this.is_use_cal_tax == true) {
    //     this.general_setting.use_cal_tax = "1";
    //     console.log("if ", this.general_setting.use_cal_tax);
    //     console.log("if ", this.is_use_cal_tax);
    //   } else {
    //     this.general_setting.use_cal_tax = "0";
    //     console.log("else ", this.general_setting.use_cal_tax);
    //   }
    // },
    changeTaxVal1() {
      console.log("this.checkuse_cal_ss changeTaxVal", this.is_use_cal_ss);
      // if(this.checkuse_cal_ss == "0"){
      //   this.is_use_cal_ss = false;
      //   console.log("if ss ", this.is_use_cal_ss);
      // }else if(this.checkuse_cal_ss == "1"){
      //   this.is_use_cal_ss = true;
      // }
      if (this.is_use_cal_ss == true) {
        this.general_setting.use_cal_ss = "1";
        console.log("if ", this.general_setting.use_cal_ss);
        console.log("if ", this.is_use_cal_ss);
      } else {
        this.general_setting.use_cal_ss = "0";
        console.log("else ", this.general_setting.use_cal_ss);
      }
      console.log("d", this.general_setting.use_cal_ss);
    },
  },
};
</script>